<template>
  <div>
    <p class="operation"><router-link to="/">{{$t('Home')}}</router-link> >> <router-link to="/productDisplay">{{$t('Project')}}</router-link> >> {{$t('development')}}</p>
    <p class="caption headline">{{ $t('Project')}}</p>
    <!--<p class="caption">产品展示</p>-->
    <p class="title">{{$t('development')}}</p>
    <div class="product-display">
      <p>&nbsp; &nbsp; &nbsp; &nbsp;{{$t('text1[0]')}}</p>
      <p>&nbsp; &nbsp; &nbsp; &nbsp;{{$t('text1[1]')}}</p>
      <img src="../assets/img/pic/pc_pd_1.png">
      <p class="imgName">{{$t('text1[2]')}}</p>
      <p>&nbsp; &nbsp; &nbsp; &nbsp;{{$t('text1[3]')}}</p>
      <img src="../assets/img/pic/pc_pd_2.png">
      <p class="imgName">{{$t('text1[4]')}}</p>
    </div>
  </div>
</template>

<script>
  export default {
    name: "pd_v1",
    data() {
      return {
      }
    }
  }
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/pd_v1.vue